import ApiService from './ApiService';
class TraderProcessService {
  async performMatchingProcess(payload) {
    try {
      const response = await ApiService.call('/secured/perform_matching_process', 'POST', payload);

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async performTradeProcess(payload) {
    try {
      const response = await ApiService.call('/secured/perform_trade_process', 'POST', payload);

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}

export default new TraderProcessService();
